import { render, staticRenderFns } from "./PpeApplyRecordEdit.vue?vue&type=template&id=71d70ba2&"
import script from "./PpeApplyRecordEdit.vue?vue&type=script&lang=js&"
export * from "./PpeApplyRecordEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports